import React, { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from "react";
import Icon from "./icons";


interface ModalProps {
    children: ReactNode,
    onClose?: (data: any) => void;
    showCloseBtn?: boolean;
}
const ModalWrapper = forwardRef(({ children, onClose = (data: any) => { }, showCloseBtn = true }: ModalProps, ref) => {
    const modalControlRef = useRef<any>(null);
    const [isOpen, setIsOpen] = useState(false);
    useImperativeHandle(ref, () => ({
        open: () => {
            if (modalControlRef.current) {
                modalControlRef.current.checked = true;
                setIsOpen(true);
            };
        },
        close: () => {
            if (modalControlRef.current) {
                modalControlRef.current.checked = false;
                setTimeout(() => {
                    setIsOpen(false);
                }, 500);
                onClose(null);
            };
        }
    }));

    return (
        <>
            <input type="checkbox" ref={modalControlRef} id="my_modal_6" className="modal-toggle" />
            <div className="modal" role="dialog">
                <div className={`modal-box p-5`}>
                    {showCloseBtn && (
                        <form method={`dialog`}>
                            <button className={`btn btn-sm btn-circle btn-ghost absolute right-3 top-5 z-10`} onClick={() => {
                                if (modalControlRef.current) {
                                    modalControlRef.current.checked = false;
                                    setTimeout(() => {
                                        setIsOpen(false);
                                    }, 500);
                                    onClose(null);
                                }
                            }}><Icon name={`close`} size={1} /></button>
                        </form>
                    )}                    
                    {isOpen && children}
                    {/*
                    <div className="modal-action">
                        <label htmlFor="my_modal_6" className="btn">Close!</label>
                    </div>
                    */}
                </div>
            </div>
        </>
    )
});

export default ModalWrapper;